// extracted by mini-css-extract-plugin
export var fadeInOut = "_2s-3";
export var icon = "_2s-4";
export var savedIndicator = "_2s-2";
export var savingIndicator = "_2s-0";
export var spin = "_2s-1";